// NotFound.jsx - A 404 that offers the three things somebody arriving on a broken
// link most likely wanted, rather than a joke and a link home.

import { Link } from "react-router";

import { Seo } from "../lib/seo.jsx";
import { ArrowRight } from "../ui/icons.jsx";
import { Reveal, StaggerBoxed } from "../ui/motion.jsx";

const OPTIONS = [
  { to: "/get-a-kit", title: "Get a free kit", body: "Free, insured, and no obligation." },
  { to: "/track", title: "Track an order", body: "We will text or email your link back to you." },
  { to: "/tools", title: "Calculators", body: "Work out what a piece is worth at today's price." },
];

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" noIndex />

      <div className="shell py-16 md:py-28">
        <Reveal as="p" from="none" className="eyebrow mb-4">404</Reveal>
        <Reveal as="h1" delay={60} className="display display-xl text-ink max-w-2xl">That page is not here any more.</Reveal>
        <Reveal as="p" delay={130} className="lede mt-5 measure text-muted">
          Either the link is old or we moved something. These are the three places people are usually
          heading.
        </Reveal>

        <StaggerBoxed
          as="div"
          step={80}
          className="grid gap-px bg-rule border border-rule sm:grid-cols-3 mt-9 max-w-3xl"
          itemClassName="bg-paper h-full"
        >
          {OPTIONS.map((option) => (
            <Link key={option.to} to={option.to} className="block h-full bg-paper p-6 group hover:bg-surface transition-colors">
              <h2 className="display display-sm text-ink flex items-start justify-between gap-3">
                {option.title}
                <ArrowRight size={17} className="text-faint shrink-0 mt-1 transition-transform group-hover:translate-x-1" />
              </h2>
              <p className="hint mt-2 leading-relaxed">{option.body}</p>
            </Link>
          ))}
        </StaggerBoxed>

        <p className="hint mt-10">
          Or call <a href="tel:+1-401-315-4653" className="link text-ink font-semibold">(401) 315-4653</a> and
          somebody will find it for you.
        </p>
      </div>
    </>
  );
}
